export const ENDPOINT = `https://${process.env.NEXT_PUBLIC_NOTIFICATIONS_SERVICE_DOMAIN_NAME}`;
